import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

export function useParallaxImages() {
  const store = useApiStore()

  const images = computed(() => store.parallaxImages)
  const imagesSorted = computed(() => store.parallaxImagesSorted)
  const loading = computed(() => store.parallaxImagesLoading)
  const error = computed(() => store.parallaxImagesError)
  const hasImages = computed(() => store.hasParallaxImages)

  const getBySortOrder = (sortOrder) => {
    return store.getParallaxImageBySortOrder(sortOrder)
  }

  const getImageId = (sortOrder) => {
    const img = store.getParallaxImageBySortOrder(sortOrder)
    return img?.image || null
  }

  const load = async () => {
    return store.loadParallaxImages()
  }

  return {
    images,
    imagesSorted,
    loading,
    error,
    hasImages,
    getBySortOrder,
    getImageId,
    load
  }
}
